import { defineComponent } from 'vue';
import { QBtn, QDialog, QTooltip, QIcon } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';
import FieldPicker from '../fieldPicker.jsx';
import SchemaForm from './SchemaForm.jsx';

export default defineComponent({
    name: 'form-tabarray-dsgn',
    components: {
        QBtn,
        QDialog,
        QTooltip,
        QIcon,
        FieldPicker,
        SchemaForm,
    },
    data: function () {
        return {
            pickervisible: false,
            picker: null,
        }
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        addField(e) {
            this.picker = <FieldPicker schema={this.schema.items} confirm={this.confirmAddField} cancel={this.cancelAddField}></FieldPicker>;
            this.pickervisible = true;

            e.cancelBubble = true;
            e.stopPropagation();
        },
        async confirmAddField(fields) {
            this.pickervisible = false;

            if (this.designmodel.$typeSchema != '/schema/public/Platform.Schema.FormControls.v1/FormControl_ArrayField' &&
                this.designmodel.$typeSchema != '/schema/public/Platform.Schema.FormControls.v1/FormControl_TabArrayField') {
                // Convert from an AutoField (or whatever it was) to a TabArrayField before appending fields
                this.designmodel.$typeSchema = '/schema/public/Platform.Schema.FormControls.v1/FormControl_TabArrayField';
                this.designmodel.type = 'tabarray';
                this.designmodel.add = 'Add';
            }

            if (!Array.isArray(this.designmodel.items))
                this.designmodel.items = [];

            const form = this.designmodel.items;
            if (!form)
                return;

            if (form.length === 1 && (typeof form[0] === 'string') && form[0] === '*')
                form.splice(0, 1);

            for (let key in fields) {
                const v = fields[key];
                if (!v) continue;

                const fieldSchema = utils.schema.resolve_Of(v.type);
                const m = utils.schema.createDefaultModel(fieldSchema, this.root);
                m.key = key;
                m.$objectid = utils.generateUUID();
                form.push(m);
            }
        },
        cancelAddField() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
        getPrimitiveTag(schema) {
            if (!schema)
                return null;

            if ('format' in schema && schema.format === 'LookupList')
                return 'string-lookup-list-dsgn';

            switch (schema.type) {
                case 'string':
                case 'text':
                case 'phonenumber':
                    if ('anyOf' in schema)
                        return 'form-anyof-dsgn';
                    if (('enum' in schema) || ('titleMap' in schema))
                        return 'form-select-dsgn';
                    return 'form-input-dsgn';
                case 'integer':
                case 'number':
                    return 'form-number-dsgn';
                case 'boolean':
                    return 'form-checkbox-dsgn';
                default:
                    return null;
            }
        },
        getTabLabel(item, index) {
            if (item && typeof item === 'object' && 'Name' in item && item.Name)
                return item.Name;

            return `[${index + 1}]`;
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const itemSchema = utils.schema.resolve_Of(this.schema.items);
        const arrayModel = Array.isArray(this.cmodel[this.schemakey]) ? this.cmodel[this.schemakey] : [];
        const itemForm = (itemSchema.type === 'object' && this.designmodel && Array.isArray(this.designmodel.items))
            ? this.designmodel.items
            : ['*'];

        const firstItem = arrayModel.length > 0 ? arrayModel[0] : {};
        const tabs = [];
        const sourceItems = arrayModel.length > 0 ? arrayModel : [firstItem];
        for (let i = 0; i < sourceItems.length && i < 5; i++) {
            const isFirst = i === 0;
            tabs.push(
                <div
                    key={`tab-${i}`}
                    class={{ 'cc-selected-item': isFirst }}
                    style={{
                        minHeight: '40px',
                        height: '40px',
                        cursor: 'default',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        borderRadius: '8px 0 0 8px',
                        marginBottom: '8px',
                        padding: '0 12px',
                        backgroundColor: isFirst ? 'rgba(44, 146, 255, 0.25)' : 'transparent',
                        color: isFirst ? '#2c92ff' : '#616161',
                        fontWeight: isFirst ? '600' : '400',
                    }}>
                    <span>{this.getTabLabel(sourceItems[i], i)}</span>
                </div>
            );
        }

        let preview;
        if (itemSchema.type === 'object') {
            preview = (
                <SchemaForm
                    name={this.designmodel.title}
                    root={this.root}
                    schema={itemSchema}
                    form={itemForm}
                    cmodel={firstItem || {}}
                    child={1}
                    selectable={true}
                    selected={this.selected$}>
                </SchemaForm>
            );
        }
        else {
            const tagName = this.getPrimitiveTag(itemSchema);
            const Tag = tagName ? utils.getComponentByTag(tagName, 'default-unknown-dsgn') : null;
            const fieldSchema = { ...itemSchema, title: `[${this.name || 'unnamed'}]` };
            const rowModel = { item: firstItem };

            if (Tag) {
                preview = (
                    <Tag
                        name={this.name}
                        schemakey="item"
                        schema={fieldSchema}
                        root={this.root}
                        cmodel={rowModel}
                        child={0}
                        readonly={itemSchema.readonly || false}>
                    </Tag>
                );
            } else {
                preview = <div>{`[${this.name || 'unnamed'}] (unsupported item type: ${itemSchema.type || 'unknown'})`}</div>;
            }
        }

        let addFieldButton;
        if (this.selected$)
            addFieldButton = (
                <div class="property-grid designer-form" key="add-field-inline">
                    <QBtn
                        flat
                        size="sm"
                        icon="mdi-plus-circle"
                        color="blue-8"
                        style={{ zIndex: 32 }}
                        onClick={(e) => this.addField(e)}>
                        <QTooltip>Add field{this.schemakey ? ` (${this.schemakey})` : ''}</QTooltip>
                    </QBtn>
                </div>
            );

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ marginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }}></div>
                <div style={{ marginBottom: '8px', fontWeight: '600' }}>{this.name}</div>
                <div style={{ display: 'flex', minWidth: '500px', borderStyle: 'solid', borderWidth: '1px', borderRadius: '8px', borderColor: 'var(--v-lightGreyBorder-base)' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '180px', padding: '8px 0 8px 8px' }}>
                        <div style={{ overflowY: 'auto', maxHeight: '300px' }}>
                            {tabs}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, padding: '5px', borderLeftStyle: 'solid', borderLeftWidth: '1px', borderLeftColor: '#e0e0e0', marginTop: '8px', marginBottom: '5px' }}>
                        <div class="q-pa-sm">
                            {preview}
                            {addFieldButton}
                        </div>
                    </div>
                </div>
                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                    <div style={{ maxWidth: '860px', maxHeight: '80vh', overflow: 'auto' }}>{this.picker}</div>
                </QDialog>
            </div>
        );
    }
});